import styles from "./personsField.module.scss";
import { IPerson, Person } from "../../models/Person";
import PersonField from "./PersonField";
import { ForwardedRef, forwardRef, useImperativeHandle } from "react";

export interface PersonsFieldProps {
    persons: IPerson[];
    isFormTypeUpdate: boolean;

    handleDataChange: (value: IPerson[]) => void;
}

export interface PersonFieldRef {
    addNew: () => void;
}

const PersonsField = forwardRef<PersonFieldRef, PersonsFieldProps>(
    (props: PersonsFieldProps, ref: ForwardedRef<PersonFieldRef>) => {
        const { handleDataChange } = props;

        const handleOnChange = (value: IPerson) => {
            const index = props.persons.findIndex((person) => person.key === value.key);

            if (index === -1) {
                return;
            }

            props.persons[index] = value;

            handleDataChange([...props.persons]);
        };

        const handleOnDelete = (key: string) => {
            const persons = props.persons.filter((person) => person.key !== key);
            handleDataChange([...persons]);
        };

        const handleOnAdd = () => {
            props.persons.push(Person.New());
            handleDataChange([...props.persons]);
        };

        const personInputs = (
            <div className={styles.fieldsWrapper}>
                {props.persons.map((person) => {
                    return (
                        <PersonField
                            key={person.key}
                            person={person}
                            handleDataChange={handleOnChange}
                            handleDelete={handleOnDelete}
                            isFormTypeUpdate={props.isFormTypeUpdate}
                        />
                    );
                })}
            </div>
        );

        // Expose methods to parent using `useImperativeHandle`
        useImperativeHandle(ref, () => ({
            addNew: () => {
                handleOnAdd();
            },
        }));

        return personInputs;
    }
);

export default PersonsField;
